import React, { FC, useMemo, useEffect } from 'react';
import { useQuery } from '@apollo/client';
import _sortBy from 'lodash/sortBy';
import ErrorMessage from '@minecraft.error-message';
import { useDrawerSearchFilterNameOrCategory, useDrawerFiltersCounts, useDrawerGlobalLoader } from '@minecraft.drawer';
import {
  FiltersNameEnum,
  generateSelectOptionsBasedOnField,
  FormItem,
  FilterDrawerType,
  useFiltersLabel,
} from '@blocs.filter';
import { FiltersCategoryNameEnum, FiltersCountNameEnum } from '../../shared/types';
import { EyeColor } from '../../FilterDrawerCollection';
import { QUERY_EYE_COLOR } from './EyeColorCategoryGraphQL';

interface Props {
  type: FilterDrawerType;
}

const EyeColorCategory: FC<Props> = ({ type }) => {
  const filtersLabelOfAudience = useFiltersLabel(type);

  const { data, error, loading } = useQuery(QUERY_EYE_COLOR);

  const { isCategoryMatchedSearch, assignOptionsToCategoryFilters } = useDrawerSearchFilterNameOrCategory(
    FiltersCategoryNameEnum.eyeColor
  );
  const { filtersCounts } = useDrawerFiltersCounts();

  const eyeColorOptions = useMemo(() => {
    return generateSelectOptionsBasedOnField(
      _sortBy(data?.eyeColors, 'name'),
      'name',
      false,
      filtersCounts?.[FiltersCountNameEnum.eyeColorId]
    );
  }, [data, filtersCounts]);

  useDrawerGlobalLoader(loading);

  useEffect(() => {
    if (eyeColorOptions.length) {
      assignOptionsToCategoryFilters({
        [FiltersNameEnum.eyeColor]: eyeColorOptions,
      });
    }
  }, [eyeColorOptions]);

  if (error) {
    return <ErrorMessage error={error} />;
  }

  return (
    isCategoryMatchedSearch && (
      <FormItem $fullWidth $marginValue={2}>
        <EyeColor name={FiltersNameEnum.eyeColor} label={filtersLabelOfAudience[FiltersNameEnum.eyeColor]} />
      </FormItem>
    )
  );
};

export default EyeColorCategory;
